const doorConstructionData = [
  { material: `UPVC Doors`, thermal_resistance: 0.211 },
  { material: `Aluminium Frames`, thermal_resistance: 0.17 },
  { material: `Aluminium Frame (with thermal break)`, thermal_resistance: 0.212 },
  { material: `Painted Wooden Window Frame`, thermal_resistance: 0.275 },
  { material: `Bamboo`, thermal_resistance: 0.191424196 },
  { material: `Chile Wood`, thermal_resistance: 0.26371308 },
  { material: `Ghana Teak Wood`, thermal_resistance: 0.18186227 },
  { material: `Rubber Wood`, thermal_resistance: 0.22334723 },
  { material: `Saag Wood`, thermal_resistance: 0.12993763 },
  { material: `Steam Beech Wood`, thermal_resistance: 0.160875161 },
  { material: `Teak Wood`, thermal_resistance: 0.158294639 },
  { material: `Oak Wood`, thermal_resistance: 0.220588235 },
  { material: `Birch Wood`, thermal_resistance: 0.220588235 },
  { material: `Maple Wood`, thermal_resistance: 0.227272727 },
  { material: `Ash Wood`, thermal_resistance: 0.23006135 },
  { material: `Southern Pine Wood`, thermal_resistance: 0.25 },
  { material: `Douglas Fir-Larch`, thermal_resistance: 0.267857143 },
  { material: `Southern Cypress`, thermal_resistance: 0.286259542 },
  { material: `Hem-Fir, Spruce-Pine-Fir`, thermal_resistance: 0.3125 },
  { material: `West Coast Woods, Cedars `, thermal_resistance: 0.340909091 },
  { material: `California Redwood`, thermal_resistance: 0.375 },
  { material: `Laminated Wood`, thermal_resistance: 0.275 },

  // Add any data above this commment
  // Any data added should follow the same syntax
];
const windowConstructionData = [
  { material: `UPVC Windows`, thermal_resistance: 0.211 },
  { material: `Aluminium Frames`, thermal_resistance: 0.17 },
  { material: `Aluminium Frame (with thermal break)`, thermal_resistance: 0.212 },
  { material: `Painted Wooden Window Frame`, thermal_resistance: 0.275 },
  { material: `Bamboo`, thermal_resistance: 0.191424196 },
  { material: `Chile Wood`, thermal_resistance: 0.26371308 },
  { material: `Ghana Teak Wood`, thermal_resistance: 0.18186227 },
  { material: `Rubber Wood`, thermal_resistance: 0.22334723 },
  { material: `Saag Wood`, thermal_resistance: 0.12993763 },
  { material: `Steam Beech Wood`, thermal_resistance: 0.160875161 },
  { material: `Teak Wood`, thermal_resistance: 0.158294639 },
  { material: `Oak Wood`, thermal_resistance: 0.220588235 },
  { material: `Birch Wood`, thermal_resistance: 0.220588235 },
  { material: `Maple Wood`, thermal_resistance: 0.227272727 },
  { material: `Ash Wood`, thermal_resistance: 0.23006135 },
  { material: `Southern Pine Wood`, thermal_resistance: 0.25 },
  { material: `Douglas Fir-Larch`, thermal_resistance: 0.267857143 },
  { material: `Southern Cypress`, thermal_resistance: 0.286259542 },
  { material: `Hem-Fir, Spruce-Pine-Fir`, thermal_resistance: 0.3125 },
  { material: `West Coast Woods, Cedars `, thermal_resistance: 0.340909091 },
  { material: `California Redwood`, thermal_resistance: 0.375 },
  { material: `Laminated Wood`, thermal_resistance: 0.275 },

  // Add any data above this commment
  // Any data added should follow the same syntax
];

export { doorConstructionData, windowConstructionData };
